import { render, staticRenderFns } from "./PackingSlip.vue?vue&type=template&id=35bb40fc&scoped=true"
import script from "./PackingSlip.vue?vue&type=script&lang=js"
export * from "./PackingSlip.vue?vue&type=script&lang=js"
import style0 from "./PackingSlip.vue?vue&type=style&index=0&id=35bb40fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb40fc",
  null
  
)

export default component.exports